<div style="width: 100%; height: 100%">
  @let _url = characterSpriteURL();
  @if (_url) {
    <app-visual-element [url]="_url" fit="contain" />
  }
</div>
